import { IHealthData } from '../Hooks/useHealthData';
import { GLUCOSE_CUSTOM_ORDERING } from './healthDataSettings';

type KeyedData = {
	key: string;
};
type SortDataFunction<T extends KeyedData> = (
	data: (T | undefined)[] | null,
	order: string[],
) => T[];

const sortDataForChart: SortDataFunction<KeyedData> = <T extends KeyedData>(
	data: (T | undefined)[] | null,
	order: string[],
) => {
	return order
		.map(key => data?.find(item => item?.key === key))
		.filter((item): item is T => item !== undefined);
};

export const sortDataForGlucoseChart = (healthData: IHealthData[] | null) => {
	return sortDataForChart(healthData, GLUCOSE_CUSTOM_ORDERING);
};
